import styled from '@emotion/styled';
import Stepper from '@eventbrite/eds-stepper';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';

import React, { useState } from 'react';
import { useSavedAutoCreatedEventFormValuesContext } from '../../../DraftEventStoreProvider';

export enum TicketsTestId {
    Container = 'TicketsContainer',
}

export const Tickets = () => {
    const [ticketQuantity, setTicketQuantity] = useState(0);
    const { savedAutoCreateFormValues } =
        useSavedAutoCreatedEventFormValuesContext();

    const ticketPrice = savedAutoCreateFormValues?.ticketsPrice;

    const handleOnAddTicket = () => {
        setTicketQuantity((prevState) => prevState + 1);
    };
    const handleOnRemoveTicket = () => {
        setTicketQuantity((prevState) => prevState - 1);
    };

    return (
        <TicketsContainer
            aria-label="Event ticket selector"
            data-testid={TicketsTestId.Container}
        >
            <Typography as="p" color="neutral-900" variant="heading-sm">
                {gettext('Tickets')}
            </Typography>
            <TicketsDisplay>
                <TicketsTitleStepperContainer>
                    <Typography
                        as="p"
                        color="neutral-900"
                        variant="body-md-bold"
                    >
                        {gettext('General Admission')}
                    </Typography>
                    <Stepper
                        minQuantitySelectable={1}
                        minValue={0}
                        maxValue={9999999}
                        totalQuantity={ticketQuantity}
                        onIncreaseOneStep={handleOnAddTicket}
                        onDecreaseOneStep={handleOnRemoveTicket}
                        onSetQuantity={(newQuantity: number) =>
                            setTicketQuantity(newQuantity)
                        }
                    />
                </TicketsTitleStepperContainer>
                <div>
                    <Typography
                        as="p"
                        color="neutral-900"
                        variant="body-md-bold"
                    >
                        ${ticketPrice}
                    </Typography>
                </div>
            </TicketsDisplay>
        </TicketsContainer>
    );
};

const TicketsDisplay = styled.div`
    border: 1px solid #eeedf2;
    border-radius: 8px;
    padding: 24px;
`;

const TicketsTitleStepperContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const TicketsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 70%;
    @media (max-width: 768px) {
        width: 100%;
    }
`;
